module.exports = __webpack_public_path__ + "static/fia_icon_large.aafe58b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fia_icon_large.png
// module id = 83
// module chunks = 35783957827783 114276838955818